/**
 *  General data manipulation methods.
 */

import lodash from 'lodash';
import DateFormat from 'dateformat';

export default {
  methods: {

    /**
     *
     */
    currency(v, prefix, c) {
      if (prefix == undefined) {
        prefix = '';
      }
      var n = v,
        c = isNaN(c = Math.abs(c)) ? 0 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
      var result = (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
      if (result == '0') {
        var s = '';
      } else {
        //console.log(v);
        var s = (v < 0) ? "-" : "";
      }
      return s + prefix + result;
    },

    /**
     *
     */
    round(number, precision = 0) {
      var shift = function (number, precision, reverseShift) {
        if (reverseShift) {
          precision = -precision;
        }
        var numArray = ("" + number).split("e");
        return +(numArray[0] + "e" + (numArray[1] ? (+numArray[1] + precision) : precision));
      };
      return shift(Math.round(shift(number, precision, false)), precision, true);
    },

    /**
     *  Given a numeric value for current year and a value for past year, return the percent change.
     *  FOR ALL VENDORS TOGETHER (see vendor specific version also)
     *  @return string in form '+10' or '-5'
     */
    getChangePercent(curValue, prevValue) {
      if (prevValue == 0 || prevValue == undefined) {
          if (curValue > 0) return '+100';
          return '0';
      }
      // =(ABS((A4-B4))/ABS(B4))*100*SIGN(A4-B4)
      var difference = Math.round(curValue - prevValue);
      var change = difference / Math.abs((prevValue || 1));
      var percentChange = Math.round(change * 100) * ((curValue-prevValue) ? 1 : -1);
      return percentChange >= 0 ? '+'+percentChange : percentChange;
    },

    /**
     *  Turns a ratio into a percent.
     *
     *  @param value A float
     *  @return A percentage value.
     */
    getPercent(value) {
      return value * 100;
    },

    /**
     *
     * @param {*} aDate
     */
    displayMonth(aDate, format = 'mmmm yyyy', addDay = false) {
      // Exit immediately if empty date.
      if (aDate == null || aDate == '') {
        return 'N/A'
      }

      // Exit early if invalid date.
      var dateCheck = new Date(aDate);
      if (dateCheck == 'Invalid Date' || dateCheck == NaN) {
        return 'N/A';
      }

      // If a date that can be processed...
      else {
        var theDate = new Date(aDate);

        // If needing to add a day to the data given (to avoid timezone issues on first of month)
        if (addDay) {
          theDate.setTime(theDate.getTime() + 1 * 86400000);
        }
        return DateFormat(theDate, format);
      }
      return aDate;
    },

    /**
     *
     */
    divide(num, den) {
      if (den == 0 || den == undefined) {
        return num;
      }
      var quotient = num / (den || 1);
      return this.round(quotient);
    },

    /**
     *
     */
    ucFirst(str) {
      return lodash.upperFirst(str);
    },

  },
};
